import { render, staticRenderFns } from "./heatmap.vue?vue&type=template&id=71540fb8&scoped=true"
import script from "./heatmap.vue?vue&type=script&lang=js"
export * from "./heatmap.vue?vue&type=script&lang=js"
import style0 from "./heatmap.vue?vue&type=style&index=0&id=71540fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71540fb8",
  null
  
)

export default component.exports